import { PaymentMethod } from '@frontend/api-payment-plans';
import {
  TokenizePaymentMethodSubmitSuccessEvent,
  TokenizePaymentMethodSuccessAchPayload,
  TokenizePaymentMethodSuccessCardPayload,
} from '../types';

export const justifiPayloadIsCardType = (
  payload: TokenizePaymentMethodSubmitSuccessEvent
): payload is TokenizePaymentMethodSuccessCardPayload => {
  return 'card' in payload.data;
};

export const justifiTokenizePayloadToCard = (
  cardPayload: TokenizePaymentMethodSuccessCardPayload
): PaymentMethod['card'] => {
  const {
    data: { card, signature },
  } = cardPayload;
  return {
    brand: card.brand,
    country: card.bin_details?.country || '',
    expMonth: Number(card.month),
    expYear: Number(card.year),
    fingerprint: signature,
    funding: card.bin_details?.funding_source || '',
    last4: card.acct_last_four,
  };
};

export const justifiTokenizePayloadToBankAccount = (
  bankPayload: TokenizePaymentMethodSuccessAchPayload
): PaymentMethod['bankAccount'] => {
  const {
    data: { bank_account },
  } = bankPayload;

  return {
    last4: bank_account.acct_last_four,
    bankName: bank_account.bank_name ?? '', // Handle null case for bank name
    accountType: bank_account.account_type as string, // Ensure this matches the expected type in your system
  };
};

export const justifiTokenizePayloadToPaymentMethod = (
  payload: TokenizePaymentMethodSubmitSuccessEvent
): PaymentMethod => {
  const type = justifiPayloadIsCardType(payload) ? 'card' : 'us_bank_account';

  const card = justifiPayloadIsCardType(payload)
    ? justifiTokenizePayloadToCard(payload)
    : ({} as PaymentMethod['card']);

  const bankAccount = !justifiPayloadIsCardType(payload)
    ? justifiTokenizePayloadToBankAccount(payload)
    : ({} as PaymentMethod['bankAccount']);

  return {
    id: payload.token,
    is_default: false, // Default is always false for Justifi tokenized payment methods
    type,
    card,
    bankAccount,
  };
};
